<script>
  import Card from '/Atoms/Card'
  import EventDate from '/Atoms/EventDate'
  import Link from '/Atoms/Link'

  export let event

  const formats = (event?.eventformat || []).map( f => f.toUpperCase()).join(", ")
  const eventDates = event?.eventDates || []

  const participantGroups = event?.relatedPeople?.filter(p => p.relationshipType === "participant") || []
  const participants = []
  for (let group of participantGroups) {
    if (group.members && group.members.length > 0) participants.push(...group.members)
  }

  console.log(event)
</script>

<Card 
    flow 
    link={{ slug: event.slug, section: "events"}}
    paddingStyle="article"  
  >

  <p class="format">
    { formats }
  </p>
  
  <h6 class="title">
    { event.title }
  </h6>
  
  <div class="people">
    { participants.join(", ") || "" }
  </div>
  
  {#each eventDates as date}
    <div class="date">
      <EventDate startDate={date.startDateAndTime} endDate={date.endDateAndTime}/>
    </div>
  {/each}
  
  {#if event.location}
    <div class="venue">
      {event.location}
    </div>
  {/if}
  
  {#if event.relatedVenues}
    <ul class="venues">
      {#each event.relatedVenues as venue}
      <li class="venue">
          {venue.title}
      </li>
      {/each}
    </ul>
  {/if}
</Card>

<style lang="scss">
  .format {
    @include typo-serif-small-caps-28;
  }
  .title {
    font-style: italic;
  }

  .title, .date {
    @include typo-serif-text-28;
  }

</style>